import { render, staticRenderFns } from "./PlayRating.vue?vue&type=template&id=57dff1ed&scoped=true"
import script from "./PlayRating.vue?vue&type=script&lang=js"
export * from "./PlayRating.vue?vue&type=script&lang=js"
import style0 from "./PlayRating.vue?vue&type=style&index=0&id=57dff1ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dff1ed",
  null
  
)

export default component.exports